export default __webpack_public_path__ + "static/media/2078_00A.f5e29ba3.jpg";